import { MOBILE_WIDTH } from '@constants/screenBreakpoints'

export const isMobileWidth = (): boolean => {
  return window.innerWidth < MOBILE_WIDTH
}
